// extracted by mini-css-extract-plugin
module.exports = {"entityNav":"EntityNavigation_entityNav__1vOGV","entityNavButton":"EntityNavigation_entityNavButton__1newc","entityNavPosition":"EntityNavigation_entityNavPosition__3J-2M"};